import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { thrash } from '../../assets/svg/other'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { getGradeOptions, deleteGradeOptions } from '../../actions/directory'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
export default function GradesOptions() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { gradesOptions } = useSelector(state => state.directory)
  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [sortField, setSortField] = useState('text')
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getGradeOptions())
  }, [])

  const handleSort = (field) => {
    if (sortField === field) setSortAsc(v => !v)
    else { setSortField(field); setSortAsc(true) }
  }

  const sortedList = useMemo(() => {
    if (!gradesOptions) return []
    return [...gradesOptions].sort((a, b) => {
      const aVal = a[sortField] ?? ''
      const bVal = b[sortField] ?? ''
      if (typeof aVal === 'number' && typeof bVal === 'number')
        return sortAsc ? aVal - bVal : bVal - aVal
      return sortAsc
        ? String(aVal).localeCompare(String(bVal), 'ru')
        : String(bVal).localeCompare(String(aVal), 'ru')
    })
  }, [gradesOptions, sortField, sortAsc])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const thrashClickHandler = (valid) => (e) => {
    e.stopPropagation()
    dispatch(deleteGradeOptions(valid))
  }

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteGradeOptions(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { text, value, valid } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{value}</td>
        <td onClick={openModal(data)}>{text}</td>
        {/* <td onClick={()=> setConfirmation({id: valid})}>{thrash()}</td> */}
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: valid, name: value })}><BiTrash /></i></td>

      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          // confirmation={confirmation?.name} 
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <Modal
        closeModal={closeModal}
        data={selectedItem}
      // height={'630px'}
      />
      <header className={styles.header}>
        <h1>Варианты значений оценок</h1>
      </header>
      <main className={styles.content}>
        <Table className={styles.table} maxHeight="none">
          <thead>
            <tr>
              <th onClick={() => handleSort('value')} style={{ cursor: 'pointer' }}>Значение</th>
              <th onClick={() => handleSort('text')} style={{ cursor: 'pointer' }}>Примечание</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sortedList?.map(renderLi)}
          </tbody>
        </Table>
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {gradesOptions?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
